<template>
    <div class="container">
        <div class="header">
            <div class="header-left">
                <el-button type="primary" @click="getData()">刷新</el-button>
            </div>
            <div class="header-right">
                <el-input v-model="filterParams.nickname" placeholder="请输入用户昵称" class="header-input" @change="loadData(1)"></el-input>
                <el-button type="primary" @click="loadData(1)">搜索</el-button>
            </div>
        </div>
        <el-table :data="records" border style="width: 100%">
            <el-table-column label="序号">
                <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                </template>
            </el-table-column>
            <el-table-column prop="nickname" label="用户昵称"></el-table-column>
            <el-table-column prop="email" label="用户邮箱"></el-table-column>
            <el-table-column prop="credits" label="用户积分"></el-table-column>
            <el-table-column prop="createdAt" label="创建时间">
                <template slot-scope="scope">
                    {{ new Date(scope.row.createdAt).toISOString().slice(0, 19).replace('T', ' ') }}
                </template>
            </el-table-column>
            <el-table-column prop="lastLoginAt" label="最后登录时间">
                <template slot-scope="scope">
                    {{ convertToDate(scope.row.lastLoginAt) }}
                </template>
            </el-table-column>
            <el-table-column label="用户状态">
                <template slot-scope="scope">
                    {{ scope.row.status == "active" ? "启用" : "禁用" }}
                </template>
            </el-table-column>
            <el-table-column label="操作" width="150">
                <template slot-scope="scope">
                    <el-button @click="handleClick('update', scope.row)" type="text" size="small">编辑</el-button>
                    <el-button @click="handleClick('delete', scope.row)" type="text" size="small">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div v-if="total > 0" class="page-wrapper">
            <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page="current"
                :page-sizes="[10, 20, 30, 40]" :page-size="size" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <el-dialog :title="getModalTitle()" :visible.sync="isHandle" width="30%" :close-on-click-modal="false">
            <div v-if="handle == 'insert' || handle == 'update'">
                <el-form ref="form" :model="handleInfo" label-width="90px">
                    <el-form-item label="用户昵称">
                        <el-input v-model="handleInfo.nickname"></el-input>
                    </el-form-item>
                    <el-form-item label="用户状态">
                        <el-select v-model="handleInfo.status" placeholder="请选择" style="width: 100%;">
                            <el-option label="启用" :value="'active'"></el-option>
                            <el-option label="禁用" :value="'banned'"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <div v-if="handle == 'delete'">您确认要删除吗？删除后将不可恢复！</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isHandle = false">取 消</el-button>
                <el-button type="primary" @click="handleSubmit()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import verifyMixin from "@/mixins/verify-mixin.js"
import listMixin from "@/mixins/list-mixin.js"

import { API, doGet } from "@/api/api.js"

export default {
    mixins: [verifyMixin, listMixin],
    data: function () {
        return {
            statusArray: [
                { value: 'active', label: '正常' },
                { value: 'banned', label: '已禁用' }
            ]
        }
    },
    methods: {
        getData: async function() {
            this.initialData();
        }
    },
    created: function () {
        this.tag = "USER";
    }
}
</script>
<style scoped lang="less">
@import "@/assets/style/list-style.less";
</style>